import styled from 'styled-components'
import colors from 'globals/colors'

export const CheckboxWrapper = styled.div`
  & > .ant-checkbox-wrapper {
    line-height: 16px;
    display: flex;
    align-items: center;
    font-size: 16px;
    color: ${colors.steelGrey};
    
    & > .ant-checkbox {
      top: 0;
      
      & + span {
        padding: 0 12px;
      }
    }
    
    & .ant-checkbox-inner {
      width: 16px;
      height: 16px;
      border: 1px solid ${colors.borderBaseColor};
      border-radius: 2.8px;

      &::after {
        top: 47%;
      }
    }
    
    & .ant-checkbox-checked .ant-checkbox-inner {
      border-color: ${colors.waterBlue};
    }
  }
`
